import { ATSSubscriptionStatus } from '@factoryfixinc/ats-interfaces';

export const ACTIVE_SUBSCRIPTION_STATUSES = [
  ATSSubscriptionStatus.ACTIVE,
  ATSSubscriptionStatus.DELINQUENT,
  ATSSubscriptionStatus.TRIAL,
];
